import { Link } from 'react-router-dom';

/**
 * כניסה נסתרת לניהול מדף הבית — לבקשת המשתמש: לא כפתור/קישור גלוי בתפריט
 * (זה משחק סוכנים חשאיים; "ADMIN" בתפריט הראשי היה שובר את האשליה עבור השחקן).
 * נקודה זעירה כמעט בלתי-נראית בפינה, אך נשארת נגישה (aria-label + focus-visible
 * תקין למקלדת) — "נסתר" ויזואלית בלבד, לא מוסתר ממשתמשי טכנולוגיה מסייעת.
 */
export function HiddenAdminLink() {
  return (
    <Link to="/admin" className="hidden-admin-link" aria-label="ניהול">
      <span aria-hidden="true" />
    </Link>
  );
}
